import { containerBoxShadow } from 'design-system/src/sharedStyles';
import styled from 'styled-components';

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0rem;
  min-height: 100%;
`;

export const TopNavAndContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const CONTENT_OUTER_WRAPPER_PADDING = 20;

export const ContentOuterWrapper = styled.div`
  padding: ${CONTENT_OUTER_WRAPPER_PADDING}px;
  padding-bottom: 32px;

  // This allows the pdf iframe to expand and fill the page
  height: 100%;
  min-width: 400px;
`;

export const CenteredContent = styled.div`
  max-width: var(--main-content-width);
  margin: 0 auto;
  min-width: 400px;
  // allow downstream elements to target this element with container queries
  container-type: inline-size;
  container-name: centered-content;
`;

// TODO(design-system): convert into Card component
export const StyledContainer = styled.div`
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--grayscale-100);
  background: var(--white);

  ${containerBoxShadow}
`;
